import * as types from './types';

export const setDimensionsExpandedCam = (data) => ({ type: types.SET_DIMENSIONS_EXPANDED_CAM, data });

export const showHideDeactivateCompanyModal = (data) => ({ type: types.SHOW_HIDE_DEACTIVATE_COMPANY_SUCCESS_MODAL, data });
